import styled from 'styled-components/native'

export const ElevationWrapper = styled.View`
  width: 100%;
  ${({ theme }) => theme.shadows.normal}
`

export const Container = styled.View`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  overflow: hidden;
`

export const HeaderContainer = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 800px;
  align-self: center;
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  background-color: ${({ theme }) => theme.colors.elementsBg};
`

export const HeaderLeft = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const ItemsScrollView = styled.ScrollView`
  max-height: 320px;
`
